module.exports = "js/webpack/f8f2bdefb19f747d6637978fb9b0782c.svg";